<script>
  import { onMount } from 'svelte';
  import { selectedStudy, selectedSite } from '$stores/selectionStore';
  import StudyHeader from '$lib/StudyHeader.svelte';
  import SiteDetails from '$lib/SiteDetails.svelte';
  import Toolbar from '$lib/Toolbar.svelte';
  import Footer from '$lib/Footer.svelte';

  let isLoading = true;
  let testData = {};

  onMount(async () => {
    // Simulate some loading
    await new Promise(resolve => setTimeout(resolve, 500));
    
    testData = {
      route: 'testSiteMessages',
      timestamp: new Date().toISOString(),
      selectedStudy: $selectedStudy,
      selectedSite: $selectedSite,
      userAgent: navigator.userAgent
    };
    
    isLoading = false;
  });
</script>

<StudyHeader />

{#if $selectedSite}
  <SiteDetails showOptionsMenu={false} />
{/if}

<Toolbar title="Test Site Messages" itemCountTitle="Test" itemCount={1}>
  <div class="flex items-center gap-2">
    <span class="text-sm text-gray-600 dark:text-gray-400">Test Route Working</span>
  </div>
</Toolbar>

{#if isLoading}
  <div class="flex flex-col justify-center items-center h-64 bg-stone-100/50 dark:bg-gray-725 mx-1">
    <div class="loader mb-4"></div>
    <p class="text-xs justify-center text-gray-700 dark:text-gray-300">Loading test data...</p>
  </div>
{:else}
  <div class="px-1 pt-0">
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h2 class="text-xl font-bold mb-4 text-gray-900 dark:text-white">Test Site Messages Route</h2>
      
      <div class="space-y-4">
        <div>
          <h3 class="font-semibold text-gray-700 dark:text-gray-300">Route Information:</h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">Route: {testData.route}</p>
          <p class="text-sm text-gray-600 dark:text-gray-400">Timestamp: {testData.timestamp}</p>
        </div>
        
        <div>
          <h3 class="font-semibold text-gray-700 dark:text-gray-300">Selected Study:</h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            {testData.selectedStudy ? testData.selectedStudy.studyName : 'None selected'}
          </p>
        </div>
        
        <div>
          <h3 class="font-semibold text-gray-700 dark:text-gray-300">Selected Site:</h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            {testData.selectedSite ? testData.selectedSite.siteId : 'None selected'}
          </p>
        </div>
        
        <div>
          <h3 class="font-semibold text-gray-700 dark:text-gray-300">Status:</h3>
          <p class="text-sm text-green-600 dark:text-green-400">✅ Route is working correctly!</p>
        </div>
      </div>
    </div>
  </div>
{/if}

<Footer>
  <div class="text-center text-sm text-gray-500 dark:text-gray-400">
    Test page created to verify routing functionality
  </div>
</Footer>

<style>
  .loader {
    border: 2px solid #20669c;
    border-radius: 50%;
    border-top: 4px solid #98acb4;
    width: 32px;
    height: 32px;
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style> 